module.exports = __webpack_public_path__ + "static/media/YM73_4.6898471a.jpg";